import React, { Component } from "react";
import companyLogo from '../assets/images/logo.png';
import "./Footer.css";

class Footer extends Component {
    render() {
        return (
            <>
                <div className="me-footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="me-footer-block">
                                    <div className="me-logo">
                                        <a href="/"><img src={companyLogo} alt="logo" className="img-fluid" /></a>
                                    </div>
                                    <ul>
                                        <li className="me-footer-emial">support@charrycoin.com</li>
                                        <li>Powered By Galiyaraa.</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="me-footer-block">
                                    <h4>Charry</h4>
                                    <ul>
                                        <li><button className="me-wallet-btn" >Wallet</button></li>
                                        <li><a href="/">ICO</a></li>
                                        <li><a href="/">Limit And Rules</a></li>
                                        <li><a href="/">Investors</a></li>
                                        <li><a href="/">Contact Support</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="me-footer-block">
                                    <h4>Transparency</h4>
                                    <ul>
                                        <li><a href="/">Whitepaper</a></li>
                                        <li><a href="/">CHY on Blockchain</a></li>
                                        <li><a href="/">Development Resources</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="me-footer-block">
                                    <h4>Join Our Community</h4>
                                    <ul className="me-footer-share">
                                        <li><a href="/"><i className="fab fa-facebook-f"></i></a></li>
                                        <li><a href="/"><i className="fab fa-twitter"></i></a></li>
                                        <li><a href="/"><i className="fab fa-linkedin-in"></i></a></li>
                                        <li><a href="/"><i className="fab fa-pinterest-p"></i></a></li>
                                        <li><a href="/"><i className="fab fa-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="me-footer-copyright">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="me-copyright-block">
                                    <p>&copy; 2020 copyright all right reserved by <a href="/">charry token</a></p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="me-copyright-block">
                                    <ul>
                                        <li><a href="/">privacy policy</a></li>
                                        <li><a href="/">Terms & condition</a></li>
                                        <li><a href="/">faq</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Footer;